import { render, staticRenderFns } from "./set-result.vue?vue&type=template&id=00778cc8&scoped=true&"
import script from "./set-result.vue?vue&type=script&lang=js&"
export * from "./set-result.vue?vue&type=script&lang=js&"
import style0 from "./set-result.vue?vue&type=style&index=0&id=00778cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00778cc8",
  null
  
)

export default component.exports